module.exports = __webpack_public_path__ + "static/media/feature.a2961728.jpg";